import ImgEli from '../../assets/experience-eli-lilly.jpg';
import ImgEY from '../../assets/experience-expedition-ey.jpg';
import ImgCodePath from '../../assets/experience-codepath.png';
import ImgAI4All from '../../assets/experience-ai4all.png';
import ImgSHPE from '../../assets/experience-shpe2025.png';
import ImgDominionEnergy from '../../assets/experience-dominionenergy.png';

const data = [
  {
    id: 6,
    title: 'Dominion Energy Student Conference',
    organization: 'Dominion Energy',
    date: '2026',
    role: 'Participant / Team 7 Pitch Challenge',
    description: 'Attended the three-day Dominion Energy Student Conference, learning about the energy industry, leadership, and the many ways people contribute to the company\'s mission. Gained insight into Dominion Energy\'s focus on People, Mission, and Future, and collaborated with Team 7 during the pitch challenge while building connections with students from diverse backgrounds.',
    link: 'https://www.linkedin.com/company/dominionenergy/',
    image: ImgDominionEnergy,
  },
  {
    id: 1,
    title: 'Discovery Day Participant',
    organization: 'Eli Lilly',
    date: '2026',
    role: 'Participant',
    description: 'Participated in Eli Lilly Discovery Day (2026), exploring pharmaceutical innovation and software solutions in the healthcare industry. Networked with industry professionals and gained insights into enterprise-scale development.',
    link: 'https://www.lilly.com/',
    image: ImgEli,
  },
  {
    id: 2,
    title: 'Expedition EY',
    organization: 'EY (Ernst & Young)',
    date: '2026',
    role: 'Participant',
    description: 'Participated in EY Expedition (2026), focusing on consulting, digital transformation, and solving real-world business problems through technology and strategy.',
    link: 'https://www.ey.com/en_us',
    image: ImgEY,
  },
  {
    id: 3,
    title: 'CodePath Programs',
    organization: 'CodePath',
    date: '2024 - 2026',
    role: 'Participant / Certificate Holder',
    description: 'Completed multiple CodePath programs (Technical Interview Prep, Web Development, Cybersecurity, Applied AI Engineering certification) between 2024 and 2026.',
    link: 'https://www.codepath.org/',
    image: ImgCodePath,
  },
  {
    id: 4,
    title: 'AI4All Fellow',
    organization: 'AI4All',
    date: '2026',
    role: 'AI/ML Fellow',
    description: 'AI4All program participation (2026) with projects and coursework on machine learning fundamentals and applied AI.',
    link: 'https://ai-4-all.org/',
    image: ImgAI4All,
  },
  {
    id: 5,
    title: 'SHPE 2025',
    organization: 'SHPE',
    date: '2025',
    role: 'Participant',
    description: 'Participated in SHPE 2025.',
    link: 'https://shpe.org/',
    image: ImgSHPE,
  },
];

export default data;
